import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { LoginContext } from "./UserContext";
import React from "react";
import Login from "./Login";
import ProductListing from "./containers/ProductListing";
import ProductDetail from "./containers/ProductDetail";
import Cart from "./containers/cart/Cart";
import Header from "./containers/Header";
import OrderDetail from "./containers/OrderDetail";

function App() {
  const { user, login, logout,products } = React.useContext(LoginContext);
  function userLogout() {
   window.location.href='/'
  }

 console.log(products,"Products in Cart")

  if (!user.auth) {
    return (
      <div className="App">
        <Login />
      </div>
    );
  } else {
    return (
      <>
      

        <BrowserRouter>
          <Routes>
            <Route path="/" element={<ProductListing />} />
            <Route path="product/:productId" element={<ProductDetail />} />
            <Route path="cart/:express"  element={<Cart />} />
             <Route path="/orderDetail"  element={<OrderDetail />} />
            
          </Routes>
        </BrowserRouter>
      </>
    );
  }
}

export default App;
